const CLOSED_CONVERSATION = 'CLOSED_CONVERSATION';
const ACCEPTED_CONVERSATION = 'ACCEPTED_CONVERSATION';
const OPENED_CONVERSATION = 'OPENED_CONVERSATION';
const CLOSED_AGENT_CONVERSATION = 'CLOSED_AGENT_CONVERSATION';
const DENIED_CONVERSATION = 'DENIED_CONVERSATION';

const DAYS_KEY_DICTIONARY = {
  شنبه: 'SATURDAY',
  'یک شنبه': 'SUNDAY',
  'دو شنبه': 'MONDAY',
  'سه شنبه': 'TUESDAY',
  چهارشنبه: 'WEDNESDAY',
  'پنج شنبه': 'THURSDAY',
  جمعه: 'FRIDAY',
};

export const createConversationsObject = (conversations) => {
  let dailyConversations = conversations.chart.chart;
  let adaptedConversations = [];
  for (let key in dailyConversations) {
    adaptedConversations.push({
      name: DAYS_KEY_DICTIONARY[dailyConversations[key].day],
      [CLOSED_CONVERSATION]: dailyConversations[key].close,
      [ACCEPTED_CONVERSATION]: dailyConversations[key].accepted,
      [OPENED_CONVERSATION]: dailyConversations[key].opened,
      [CLOSED_AGENT_CONVERSATION]: dailyConversations[key].closedAgent,
      [DENIED_CONVERSATION]: dailyConversations[key].denied,
    });
  }

  return {
    chart: {
      close: conversations.all.closed,
      ...conversations.chart,
      chart: adaptedConversations,
    },
  };
};
